import { Value } from 'src_common/common/mobx-utils/Value';
import { Map } from 'immutable';

export class ReduxRawState {
    protected nominal: 'nominal' = 'nominal' as const;

    private readonly state: Value<Record<string, unknown>>;

    public readonly forceSynchronisation: () => void;

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    public constructor(private readonly store: any) {
        this.state = new Value({});

        let prevValue = Map();

        this.forceSynchronisation = (): void => {
            const value = store.getState();
            if (prevValue !== value) {
                prevValue = value;
                this.state.setValue(value);
            }
        };

        this.forceSynchronisation();

        //On the server side, this function will never run
        setInterval(this.forceSynchronisation, 200);
    }

    public dispatch = (action: unknown): void => {
        this.store.dispatch(action);
        this.forceSynchronisation();
    };

    /**
     * Use the 'getStateReactive' method
     * @returns
     */
    public getState = (): Record<string, unknown> => {
        return this.store.getState();
    };

    public getStateReactive = (): Record<string, unknown> => {
        return this.state.getValue();
    };

    public subscribe(callback: () => void): () => void {
        return this.store.subscribe(callback);
    }
}
